import { ContactListApi } from 'api/ContactListApi';
import { backendApiClient } from 'container/backendApiClient';

export const contactListApi = new ContactListApi(backendApiClient);
